import { motion } from 'framer-motion';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const testimonials = [
  {
    name: 'Carlos M.',
    service: 'Reparo de notebook',
    text: 'Meu notebook voltou a funcionar perfeitamente. Orçamento claro, prazo cumprido e atendimento muito profissional.',
    rating: 5,
  },
  {
    name: 'Ana Paula R.',
    service: 'Conserto de TV',
    text: 'A TV parou de ligar e a equipe diagnosticou e resolveu rapidamente. Recomendo pela honestidade e qualidade do serviço.',
    rating: 5,
  },
  {
    name: 'Roberto S.',
    service: 'Manutenção de PC',
    text: 'Fizeram upgrade de SSD e limpeza completa. O computador ficou muito mais rápido. Excelente custo-benefício.',
    rating: 5,
  },
  {
    name: 'Fernanda L.',
    service: 'Orçamento via WhatsApp',
    text: 'Atendimento ágil pelo WhatsApp, sem surpresas no valor final. Transparência do início ao fim do reparo.',
    rating: 5,
  },
];

function TestimonialsSection() {
  return (
    <section className="section-padding surface-section" aria-label="Depoimentos de clientes">
      <div className="container-responsive">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-8 xs:mb-10 sm:mb-12"
        >
          <h2 className="text-fluid-2xl font-bold text-gray-800 dark:text-gray-100 mb-3">
            O que nossos clientes dizem
          </h2>
          <p className="text-fluid-base text-gray-600 dark:text-gray-400 max-w-2xl mx-auto px-4">
            A satisfação de quem confia na Notemaster é nossa maior referência.
          </p>
          <div className="w-16 xs:w-20 sm:w-24 md:w-32 h-0.5 xs:h-1 bg-primary-600 mx-auto mt-4 xs:mt-5 rounded-full" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 xs:gap-5 sm:gap-6">
          {testimonials.map((item, index) => (
            <motion.article
              key={item.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: index * 0.08 }}
              viewport={{ once: true }}
              className="card-modern flex flex-col h-full border border-gray-100"
            >
              <FaQuoteLeft className="text-primary-200 text-xl mb-3" aria-hidden="true" />
              <div className="flex gap-0.5 mb-3" aria-label={`${item.rating} de 5 estrelas`}>
                {Array.from({ length: item.rating }).map((_, starIndex) => (
                  <FaStar key={starIndex} className="text-accent-400 text-sm" aria-hidden="true" />
                ))}
              </div>
              <p className="text-sm xs:text-base text-gray-700 flex-grow leading-relaxed">
                "{item.text}"
              </p>
              <div className="mt-5 pt-4 border-t border-gray-100">
                <p className="font-semibold text-gray-900 text-sm xs:text-base">{item.name}</p>
                <p className="text-xs xs:text-sm text-primary-600 mt-0.5">{item.service}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
